import { io } from 'socket.io-client';

let socket = null;

export function connect(recordId: string, syncCallback: CallableFunction) {
  socket = io(process.env.SOCKET_IO_URL, {
    path: '/realtime',
  });

  socket.emit('join', {
    recordId,
  });

  socket.on('sync', (customer: any) => {
    syncCallback(customer);
  });
}

export function getSocketId() {
  return socket.id;
}

export function sync(recordId: string, customer: any) {
  socket.emit('sync', {
    recordId,
    customer,
  });
}
